import React from 'react';

function medium() {
    return (
        <svg width="50" height="52" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_0_1)">
                <line x1="16.5" y1="8.5" x2="16.5" y2="27.5" stroke="#3EBFE8" stroke-width="3" stroke-linecap="round"/>
            </g>
            <g filter="url(#filter1_d_0_1)">
                <line x1="24.5" y1="8.5" x2="24.5" y2="27.5" stroke="#3EBFE8" stroke-width="3" stroke-linecap="round"/>
            </g>
            <g filter="url(#filter2_d_0_1)">
                <line x1="32.5" y1="8.5" x2="32.5" y2="27.5" stroke="#3EBFE8" stroke-width="3" stroke-linecap="round"/>
            </g>
            <line x1="40.5" y1="8.5" x2="40.5" y2="27.5" stroke="#DEE3EF" stroke-width="3" stroke-linecap="round"/>
            <line x1="48.5" y1="8.5" x2="48.5" y2="27.5" stroke="#DEE3EF" stroke-width="3" stroke-linecap="round"/>
            <defs>
                <filter id="filter0_d_0_1" x="0" y="0" width="33" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="8"/>
                    <feGaussianBlur stdDeviation="7.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.243137 0 0 0 0 0.74902 0 0 0 0 0.909804 0 0 0 0.2 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape"/>
                </filter>
                <filter id="filter1_d_0_1" x="8" y="0" width="33" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="8"/>
                    <feGaussianBlur stdDeviation="7.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.243137 0 0 0 0 0.74902 0 0 0 0 0.909804 0 0 0 0.2 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape"/>
                </filter>
                <filter id="filter2_d_0_1" x="16" y="0" width="33" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="8"/>
                    <feGaussianBlur stdDeviation="7.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.243137 0 0 0 0 0.74902 0 0 0 0 0.909804 0 0 0 0.2 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape"/>
                </filter>
            </defs>
        </svg>




    );
}

export default medium;
